"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _locales = _interopRequireDefault(require("../locales.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Pagination = function Pagination(_ref) {
  var locale = _ref.locale,
      page = _ref.page,
      size = _ref.size,
      pages = _ref.pages,
      rowsLength = _ref.rowsLength,
      onPageChange = _ref.onPageChange,
      onSizeChange = _ref.onSizeChange;
  return _react["default"].createElement("div", {
    className: "pagination-wrapper"
  }, _react["default"].createElement("div", {
    className: "left"
  }, _react["default"].createElement("div", {
    className: "form-group"
  }, _react["default"].createElement("select", {
    id: "size",
    name: "size",
    className: "form-control form-control-sm",
    value: size,
    onChange: onSizeChange
  }, _react["default"].createElement("option", {
    value: "10"
  }, "10"), _react["default"].createElement("option", {
    value: "25"
  }, "25"), _react["default"].createElement("option", {
    value: "50"
  }, "50"), _react["default"].createElement("option", {
    value: "100"
  }, "100"))), _react["default"].createElement("p", {
    className: "description"
  }, "\n            ".concat(_locales["default"][locale]['table-pagination-desc-1'], " \n            ").concat((page - 1) * size + 1, " \n            ").concat(_locales["default"][locale]['table-pagination-desc-2'], " \n            ").concat(page * size, " ").concat(_locales["default"][locale]['table-pagination-desc-3'], " \n            ").concat(rowsLength, " \n            ").concat(_locales["default"][locale]['table-pagination-desc-4'], "\n          "))), _react["default"].createElement("nav", null, _react["default"].createElement("ul", {
    className: "pagination pagination-sm"
  }, _react["default"].createElement("li", {
    className: "page-item"
  }, _react["default"].createElement("button", {
    type: "button",
    className: "page-link",
    disabled: page === 1,
    onClick: function onClick() {
      onPageChange('prev');
    }
  }, _locales["default"][locale]['table-pagination-prev'])), pages.map(function (btn, index) {
    return _react["default"].createElement("li", {
      key: index,
      className: btn === page ? 'page-item active' : 'page-item'
    }, _react["default"].createElement("button", {
      type: "button",
      className: "page-link",
      onClick: function onClick() {
        onPageChange(btn);
      }
    }, btn));
  }), _react["default"].createElement("li", {
    className: "page-item"
  }, _react["default"].createElement("button", {
    type: "button",
    className: "page-link",
    disabled: page === Math.ceil(rowsLength / size),
    onClick: function onClick() {
      onPageChange('next');
    }
  }, _locales["default"][locale]['table-pagination-next'])))));
};

Pagination.propTypes = {
  locale: _propTypes["default"].string,
  page: _propTypes["default"].number,
  size: _propTypes["default"].string,
  pages: _propTypes["default"].array,
  rowsLength: _propTypes["default"].number,
  onPageChange: _propTypes["default"].func,
  onSizeChange: _propTypes["default"].func
};
Pagination.defaultProps = {
  locale: 'en',
  page: 1,
  size: 10,
  pages: [],
  rowsLength: 0,
  onPageChange: function onPageChange(f) {
    return f;
  },
  onSizeChange: function onSizeChange(f) {
    return f;
  }
};
var _default = Pagination;
exports["default"] = _default;